import { Component, HostBinding, inject, signal } from '@angular/core';
import { PAGES } from '@constants/constants';
import { LayoutComponent } from '@layout/layout.component';
import { TPipe, TRANSLATION_PREFIX } from '@pipes/t.pipe';
import { CONTROLS_SUBTITLE } from './controls';

@Component({
  selector: 'abb-controls',
  standalone: true,
  template: `
    <page-layout
      [page]="PAGES.CONTROLS"
      [title]="'Controls' | t"
      (tabchange)="tabChange($event)"
    >
      <span
        subtitle
        [innerHTML]="subtitle().key | t : subtitle().params"
      ></span>
    </page-layout>
  `,
  styles: ``,
  imports: [LayoutComponent, TPipe],
  providers: [
    {
      provide: TRANSLATION_PREFIX,
      useValue: 'controls',
    },
  ],
  host: { class: 'flex-1' },
})
export class ControlsComponent {
  @HostBinding('attr.id') componentid = 'controls-component';
  readonly PAGES: PAGES = PAGES;
  tot: number = 50;
  totAlerts: number | string = 'one';
  tab = signal<string>('');
  subtitle = inject(CONTROLS_SUBTITLE);

  constructor() {}

  tabChange(tab: string) {
    this.tab.set(tab);
  }
}
